export const DEFAULT_HERO_TAB = 'performance'

export const HERO_TABS = [
  { key: 'performance', label: 'Performance' },
  { key: 'players', label: 'Players' },
  { key: 'items', label: 'Items' },
  { key: 'ranks', label: 'Ranks' },
  { key: 'matches', label: 'Recent Matches' },
  { key: 'builds', label: 'Recent Builds' },
]

export const isValidHeroTab = (tab) => HERO_TABS.some((entry) => entry.key === tab)

export const normalizeHeroTab = (tab) => (isValidHeroTab(tab) ? tab : DEFAULT_HERO_TAB)
